import config from './config'

/*
Lista dos métodos do vue-resource
  - get(url, [config])
  - head(url, [config])
  - delete(url, [config])
  - jsonp(url, [config])
  - post(url, [body], [config])
  - put(url, [body], [config])
  - patch(url, [body], [config])
*/

// Autenticação
export const gerarUrlLogin = () => `${config.backUrl}/api/auth`
export const gerarUrlGetAuthUserPool = () => `${config.backUrl}/api/auth-user-pool/frontend`
export const gerarUrlRegisterCognito = () => `${config.backUrl}/web/login-cognito`
export const gerarUrlLogout = () => `${config.backUrl}/api/auth-logout`
export const gerarUrlRedirectSSORoute = (compManId) => `${config.backUrl}/api/redirect-sso-route/${compManId}`
export const gerarUrlAmbientesDoUsuario = (emailOuCpf) => `${config.backUrl}/api/ambientes-do-usuario/${emailOuCpf}`
export const gerarUrlDoKeycloak = () => `${config.keycloakUrl}`

// Solicitação de HE
export const gerarUrlPedidoDeHorasExtras = () => `${config.backUrl}/api/planejamento-de-escala/horas-extras`

export const gerarUrlJornadaDoDia = () => `${config.backUrl}/api/timesheet-partial/djs`

// Firebase Token - Notificação
export const gerarUrlSalvarTokenFirebase = (idEmpregado) => `${config.backUrl}/api/user/firebase-token/employee/${idEmpregado}`

// Cadastro de Coletores
export const gerarUrlColetores = () => `${config.gerenciadorUrl}/coletores`
export const gerarUrlEmpregados = () => `${config.gerenciadorUrl}/empregados`
export const gerarUrlLocaisDeTrabalho = () => `${config.gerenciadorUrl}/locais`
export const gerarUrlPerfisDeColetor = () => `${config.gerenciadorUrl}/perfis-de-coletor`
export const gerarUrlColetor = (coletorId) => `${config.gerenciadorUrl}/coletor/${coletorId}`
export const gerarUrlCriarColetorColetivo = () => `${config.gerenciadorUrl}/coletores/coletivo`
export const gerarUrlCriarColetorPessoal = () => `${config.gerenciadorUrl}/coletores/pessoal`
export const gerarUrlCriarColetorPessoalSSO = () => `${config.gerenciadorUrl}/coletores/pessoal/sso`
export const gerarUrlRestaurarColetor = (coletorId) => `${config.gerenciadorUrl}/coletor/${coletorId}/restaurar`
export const gerarUrlLogarColetor = () => `${config.gerenciadorUrl}/logar-coletor`
export const gerarUrlRenovarChaveAcesso = () => `${config.gerenciadorUrl}/renovar-chave-dispositivo`
export const gerarUrlRedirecionamento = () => `${config.gerenciadorUrl}/urls-de-redirecionamento/bate-ponto`

// sincronização
export const gerarUrlSincronizacaoWeb = () => `${config.gerenciadorUrl}/sincronizacao-web`
export const gerarUrlSincronizacaoUsuario = (pin) => {
  return pin
    ? `${config.gerenciadorUrl}/sincronizacao-web/empregado/${pin}`
    : `${config.gerenciadorUrl}/sincronizacao-web/empregado`
}
export const gerarUrlHorarioLocalDeTrabalho = (localId) => `${config.reppUrl}/horario-do-local/${localId}`
export const gerarUrlHorarioLocalizacao = (latitude, longitude) => `${config.reppUrl}/horario-localizacao/${latitude}/${longitude}`
export const gerarUrlHorarioTimeZone = (timezone) => `${config.reppUrl}/horario-timezone/${timezone}`

// Marcacao de ponto
export const gerarUrlValidacoesPreMarcacao = (empregadoId, localId) => `${config.reppUrl}/validacoes-pre-marcacao/${empregadoId}/${localId}`
export const gerarUrlMarcacao = () => `${config.reppUrl}/marcacao`
export const gerarUrlComprovanteDados = (marcacaoId) => `${config.reppUrl}/comprovante/${marcacaoId}/dados`
export const gerarUrlInfosExtrasMarcacao = () => `${config.gerenciadorUrl}/infos-extras-marcacoes`
export const gerarUrlInfosExtraMarcacoesAudios = () => `${config.gerenciadorUrl}/infos-extras-marcacoes/audios`
export const gerarUrlComprovantePdf = (marcacaoId) => `${config.reppUrl}/comprovante/${marcacaoId}/pdf`

// Visuais
export const gerarUrlWebVisual = (idCliente, idColetor) => {
  return idCliente && idColetor
    ? `${config.gerenciadorUrl}/layout-customizado/${idCliente}/${idColetor}`
    : `${config.gerenciadorUrl}/layout-customizado`
}
export const gerarUrlGetS3File = () => 'https://lar21css.s3-sa-east-1.amazonaws.com/new-web-version'
export const gerarUrlConsultaIp = () => 'https://us-central1-pontotel-tools.cloudfunctions.net/consultar-ip'
